export default __webpack_public_path__ + "static/media/audit.7d242005.svg";